import React from 'react';
import { getAnalistaDisplayNome } from '../../FuncoesGerais/tipoAnalista';

function ChamadoCollaboratorsCard({
    colaboradores,
    carregandoColaboradores,
    opcoesColaboradores,
    novoColaboradorId,
    onNovoColaboradorChange,
    onAdicionar,
    onRemover,
    salvandoColaborador,
    carregandoOpcoesColaboradores,
    readOnly,
}) {
    return (
        <div className="chamado-sidebar-card chamado-collab-card">
            <h4 className="chamado-sidebar-card-titulo">Colaboradores</h4>
            {carregandoColaboradores ? (
                <p className="chamado-collab-loading">Carregando...</p>
            ) : colaboradores.length === 0 ? (
                <p className="chamado-collab-vazio">Nenhum colaborador adicionado ainda.</p>
            ) : (
                <ul className="chamado-collab-list">
                    {colaboradores.map((c) => (
                        <li key={c.id} className="chamado-collab-item">
                            <span>{c.nome || `Usuário ${c.id}`}</span>
                            {c.grupo && <span className="chamado-collab-grupo">{c.grupo}{c.papel ? ` • ${c.papel}` : ''}</span>}
                            {!readOnly && (
                            <button
                                type="button"
                                className="chamado-collab-remove"
                                onClick={() => onRemover(c.id)}
                                disabled={salvandoColaborador}
                                title="Remover colaborador"
                                aria-label="Remover"
                            >
                                <i className="fas fa-times" aria-hidden="true" />
                            </button>
                            )}
                        </li>
                    ))}
                </ul>
            )}
            {!readOnly && (
            <div className="chamado-collab-add">
                <select
                    className="chamado-collab-select"
                    value={novoColaboradorId}
                    onChange={(e) => onNovoColaboradorChange(e.target.value)}
                    aria-label="Selecione um colaborador"
                >
                    <option value="">Selecione um colaborador</option>
                    {opcoesColaboradores.map((u) => (
                        <option key={u.id} value={u.id}>{getAnalistaDisplayNome(u.nome || `Usuário ${u.id}`, u)}</option>
                    ))}
                </select>
                {carregandoOpcoesColaboradores && <span className="chamado-collab-opcoes-loading">Carregando...</span>}
                <button
                    type="button"
                    className="chamado-collab-btn-add"
                    onClick={onAdicionar}
                    disabled={salvandoColaborador || !novoColaboradorId.trim()}
                >
                    Adicionar colaborador
                </button>
            </div>
            )}
        </div>
    );
}

export default ChamadoCollaboratorsCard;
